// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exchange-rates-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 10px;
  border: 1px solid #213555;
  background-color: #f1e2d7;
  font-size: 14px;
}
.exchange-rates-table__colgroup-item:nth-child(1) {
  width: 195px;
}
.exchange-rates-table__colgroup-item:nth-child(2) {
  width: 100px;
}
.exchange-rates-table__colgroup-item:nth-child(3) {
  width: 45px;
}
.exchange-rates-table__colgroup-item:nth-child(4) {
  width: auto;
}
.exchange-rates-table__colgroup-item:nth-child(5) {
  width: auto;
}
@media (max-width: 720px) {
  .exchange-rates-table__colgroup-item:nth-child(1) {
    width: auto;
  }
  .exchange-rates-table__colgroup-item:nth-child(2) {
    width: 100px;
  }
  .exchange-rates-table__colgroup-item:nth-child(3) {
    width: 45px;
  }
  .exchange-rates-table__colgroup-item:nth-child(4) {
    width: 0;
  }
  .exchange-rates-table__colgroup-item:nth-child(5) {
    width: 0;
  }
}
.exchange-rates-table__separator {
  padding: 0px !important;
  height: 0px !important;
  border-top: 1px solid #213555;
}
.exchange-rates-table tbody {
  -webkit-overflow-scrolling: touch;
}
.exchange-rates-table th {
  background-color: #F5EFE7;
  padding: 4px;
}
.exchange-rates-table th:first-child {
  border-top-left-radius: 10px;
}
.exchange-rates-table th:nth-child(3) {
  border-top-right-radius: 10px;
}
.exchange-rates-table td {
  border-radius: 0px;
  padding: 4px;
  background-color: rgba(241, 226, 215, 0.75);
}
.exchange-rates-table td:first-child {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.exchange-rates-table td:last-child {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
@media (max-width: 720px) {
  .exchange-rates-table {
    font-size: 14px;
    border-radius: 8px;
    border: 1px solid #213555;
  }
  .exchange-rates-table th {
    padding: 2px;
    height: 30px;
  }
  .exchange-rates-table th:first-child {
    border-top-left-radius: 8px;
    padding-left: 4px;
  }
  .exchange-rates-table th:nth-child(2) {
    border-top-right-radius: 8px;
  }
  .exchange-rates-table td {
    padding: 2px;
  }
  .exchange-rates-table td:first-child {
    padding-left: 4px;
  }
  .exchange-rates-table td:nth-child(3) {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/sections/RatesSection/components/ExchangeRatesTable.scss","webpack://./src/utils/_themeConstants.scss"],"names":[],"mappings":"AAQA;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBARsB;EAStB,yBAAA;EAGA,yBCXa;EDYb,eAAA;AATF;AAYI;EAAiB,YAAA;AATrB;AAUI;EAAiB,YAAA;AAPrB;AAQI;EAAiB,WAAA;AALrB;AAMI;EAAiB,WAAA;AAHrB;AAII;EAAiB,WAAA;AADrB;AAGI;EACE;IAAiB,WAAA;EAArB;EACI;IAAiB,YAAA;EAErB;EADI;IAAiB,WAAA;EAIrB;EAHI;IAAiB,QAAA;EAMrB;EALI;IAAiB,QAAA;EAQrB;AACF;AALE;EACE,uBAAA;EACA,sBAAA;EACA,6BAAA;AAOJ;AAJE;EACE,iCAAA;AAMJ;AAHE;EACE,yBCvCW;EDwCX,YA9Ce;AAmDnB;AAHI;EAAgB,4BA7CI;AAmDxB;AALI;EAAiB,6BA9CG;AAsDxB;AALE;EACE,kBAAA;EACA,YAtDe;EAuDf,2CAAA;AAOJ;AALI;EACE,4BAAA;EACA,+BAAA;AAON;AALI;EACE,6BAAA;EACA,gCAAA;AAON;AAHE;EA7DF;IA8DI,eAAA;IACA,kBAjEmB;IAkEnB,yBAAA;EAMF;EAJE;IACE,YAxEY;IAyEZ,YAAA;EAMJ;EAHI;IAAgB,2BAzEC;IAyE8C,iBAAA;EAOnE;EANI;IAAiB,4BA1EA;EAmFrB;EANE;IACE,YAjFY;EAyFhB;EANI;IACE,iBAAA;EAQN;EANI;IACE,4BApFe;IAqFf,+BArFe;EA6FrB;AACF","sourcesContent":["@use \"../../../utils/themeConstants\";\r\n\r\n$paddings-desktop: 4px;\r\n$paddings-mobile: 2px;\r\n\r\n$border-radius-desktop: 10px;\r\n$border-radius-mobile: 8px;\r\n\r\n.exchange-rates-table {\r\n  width: 100%;\r\n  table-layout: fixed;\r\n  border-collapse: separate;\r\n  border-spacing: 0;\r\n  border-radius: $border-radius-desktop;\r\n  border: 1px solid themeConstants.$color-dark;\r\n\r\n  $main-content-background-color: themeConstants.$color-light1;\r\n  background-color: $main-content-background-color;\r\n  font-size: 14px;\r\n  \r\n  &__colgroup-item {\r\n    &:nth-child(1) { width: 195px; }\r\n    &:nth-child(2) { width: 100px; }\r\n    &:nth-child(3) { width: 45px; }\r\n    &:nth-child(4) { width: auto; }\r\n    &:nth-child(5) { width: auto; }\r\n\r\n    @media(max-width: themeConstants.$mobile-cutoff-width) {\r\n      &:nth-child(1) { width: auto; }\r\n      &:nth-child(2) { width: 100px; }\r\n      &:nth-child(3) { width: 45px; }\r\n      &:nth-child(4) { width: 0; }\r\n      &:nth-child(5) { width: 0; }\r\n    }\r\n  }\r\n\r\n  &__separator {\r\n    padding: 0px !important;\r\n    height: 0px !important;\r\n    border-top: 1px solid themeConstants.$color-dark;\r\n  }\r\n\r\n  tbody {\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n\r\n  th {\r\n    background-color: themeConstants.$color-bright;\r\n    padding: $paddings-desktop;\r\n\r\n    &:first-child { border-top-left-radius: $border-radius-desktop; }\r\n    &:nth-child(3) { border-top-right-radius: $border-radius-desktop; }\r\n  }\r\n\r\n  td {\r\n    border-radius: 0px;\r\n    padding: $paddings-desktop;\r\n    background-color: rgba($main-content-background-color, 0.75);\r\n\r\n    &:first-child {\r\n      border-top-left-radius: 10px;\r\n      border-bottom-left-radius: 10px;\r\n    }\r\n    &:last-child {\r\n      border-top-right-radius: 10px;\r\n      border-bottom-right-radius: 10px;\r\n    }\r\n  }\r\n\r\n  @media(max-width: themeConstants.$mobile-cutoff-width) {\r\n    font-size: 14px;\r\n    border-radius: $border-radius-mobile;\r\n    border: 1px solid themeConstants.$color-dark;\r\n\r\n    th {\r\n      padding: $paddings-mobile;\r\n      height: 30px;\r\n\r\n      \r\n      &:first-child { border-top-left-radius: $border-radius-mobile; padding-left: 4px; }\r\n      &:nth-child(2) { border-top-right-radius: $border-radius-mobile; }\r\n    }\r\n  \r\n    td {\r\n      padding: $paddings-mobile;\r\n\r\n      &:first-child {\r\n        padding-left: 4px;\r\n      }\r\n      &:nth-child(3) {\r\n        border-top-right-radius: $border-radius-mobile;\r\n        border-bottom-right-radius: $border-radius-mobile;\r\n      }\r\n    }\r\n  }\r\n}","$color-dark: #213555;\r\n$color-dark-highlight: #3E5879;\r\n\r\n$color-medium: #D8C4B6;\r\n\r\n$color-light: #ebd9cd;\r\n$color-light1: #f1e2d7;\r\n\r\n$color-bright: #F5EFE7;\r\n$color-brightest: #fff9f2;\r\n\r\n$mobile-cutoff-width: 720px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
